import { Form, Formik } from "formik";
import MDTextInput from "../components/Inputs/MDTextInput";
import MDSelectInput from "../components/Inputs/MDSelect";
import MDDateAndTimePicker from "../components/Inputs/MDDateAndTimePicker";
import AutoFocusError from "../components/AutoFocusError";
import { SellerStep1Schema, SellerStep5Schema } from "../validations";
import { useRef, useState } from "react";
import {
  bathOptions,
  bedOptions,
  buyerHomeTypeOptions,
  buyerInterestedInOptions,
  buyerMovingOptions,
  buyerSituationOptions,
  genericBuyerMeetingOptions,
  genericSellBeforeBuyingOptions,
  priceRangeOptions,
  spokenWithAdvisorOptions,
  workingWithAgentOptions,
} from "../utils/enum";
import axios from "axios";
import { useLocation } from "react-router";
import dayjs from "dayjs";
import StartBuyingHomeThanks from "../components/ThanksUser/StartBuyingHomeThanks";
import MDMultiAutoComplete from "../components/Inputs/MDMultiAutoComplete";
import { config } from "../utils/config";
import FormFirstSlide from "../components/FormFirstSlide";

const StartBuyingHomeForm = ({ isMultiPartForm }) => {
  const typingTimeout = useRef(null);
  const [currentStep, setCurrentStep] = useState(isMultiPartForm ? 2 : 1);
  const [isWhatsApp, setIsWhatsApp] = useState(false);
  const [addressOptions, setAddressOptions] = useState([]);
  const [phoneBtnClick, setPhoneBtnClick] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [submitError, setSubmitError] = useState(false);
  const [selectedCities, setSelectedCities] = useState();

  const userAddress = queryParams.get("address");
  const windowUrl = window.location.href;
  const marketingSource = queryParams.get("source");

  const handleAddressChange = async (event, value) => {
    const inputValue = value.trimStart();
    if (inputValue.length > 0) {
      if (typingTimeout.current) {
        clearTimeout(typingTimeout.current);
      }

      typingTimeout.current = setTimeout(async () => {
        try {
          const headers = {
            "Content-Type": "application/json",
          };

          const response = await axios.get(
            `https://cn.chishtiglobal.ca/api/Data/AddressResponse/${value}`,
            headers
          );

          if (response?.data?.result === 1) {
            const filteredCities = response?.data?.data?.reduce((acc, item) => {
              const exists = acc.find(
                (i) => i.responseTitle === item.responseTitle
              );
              if (!exists) {
                acc.push({
                  responseTitle: item.responseTitle,
                  responseDesc: item.responseDesc,
                });
              }
              return acc;
            }, []);

            setAddressOptions(filteredCities);
          }
        } catch (error) {
          console.log(error);
        }
      }, 300);
    }
  };

  const initialValues = {
    name: "",
    email: "",
    phone: "",
    sellBeforeBuying: "",
    movingTimeLine: "",
    homeType: "",
    buyerSituation: "",
    interestedIn: "",
    priceRange: "",
    spokenWithAdvisor: "",
    bed: "",
    bath: "",
    specificRequirements: "",
    workedWithAgent: "",
    meetingTime: null,
    meetingOpinion: "",
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    setSubmitError(false);

    if (currentStep === 5) {
      resetForm({ values: initialValues, submitCount: 0 });
      setCurrentStep(1);
      return;
    }

    try {
      const city = selectedCities
        ? selectedCities?.map((city) => city.responseTitle).join(", ")
        : "";
      const data = {
        ...values,
        meetingTime: values?.meetingTime
          ? dayjs(values?.meetingTime).format("YYYY-MM-DDTHH:mm:ss.SSS")
          : "",
        address: userAddress || "",
        city,
        originUrl: windowUrl,
        category: "BuyerGeneric",
        formType: "",
        marketingSource: marketingSource || "",
      };
      const response = await axios.post(
        "https://cn.chishtiglobal.ca/formconnector/sale2solddefault",
        data
      );
      if (response?.data?.result === 1) {
        window.scrollTo(0, 0);
        setCurrentStep(currentStep + 1);
        setSubmitError(false);

        if (isWhatsApp) {
          window.open(
            `https://api.whatsapp.com/send?phone=${
              config?.platformWhatsAppNumber
            }&amp;text=Hey ${config?.platformTitle}, My Name is ${
              values?.name || ""
            }. I am looking to Buy. Can you connect with me As soon as possible.`,
            "_blank"
          );
        }

        if (phoneBtnClick) {
          window.location.href = `tel:${
            config?.platformPhoneNumber || "+16476490400"
          }`;
        }
      } else {
        setSubmitError(true);
      }
    } catch (error) {
      setSubmitError(true);
      console.error(error);
    } finally {
      setIsWhatsApp(false);
      setPhoneBtnClick(false);
      setSubmitting(false);
      resetForm({ values, submitCount: 0 });
    }
  };

  return (
    <div className="form_mainContainer">
      <div className="agent_profile d-flex align-items-center gap-3">
        <img
          src="https://config.assignmentsold.ca/Attachments/Newhomez-Agent-Profile.jpg"
          alt="Agent-Profle"
        />
        <div>
          <h3 className="agent_name m-0">
            {config?.platformTitle || "Sale2Sold"}
          </h3>
          <p className="agent_category">Listing Agent</p>
        </div>
      </div>
      <div className="form_container">
        <Formik
          initialValues={initialValues}
          validationSchema={
            currentStep === 1
              ? SellerStep1Schema
              : currentStep === 4
              ? SellerStep5Schema
              : null
          }
          onSubmit={handleSubmit}
        >
          {({
            isSubmitting,
            errors,
            handleChange,
            handleBlur,
            values,
            submitCount,
            submitForm,
            setFieldValue,
          }) => (
            <Form className="w-100 gap-3 mt-4 d-flex flex-column">
              <AutoFocusError />

              {currentStep === 1 && (
                <>
                  <FormFirstSlide
                    values={values}
                    errors={errors}
                    submitCount={submitCount}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                  />
                </>
              )}

              {currentStep === 2 && (
                <>
                  <div>
                    <p className="label_heading">
                      What Area of the City are you looking to buy in
                    </p>

                    <MDMultiAutoComplete
                      options={addressOptions}
                      values={selectedCities}
                      onChange={(e, newValue) => setSelectedCities(newValue)}
                      onInputChange={handleAddressChange}
                      getOptionLabel={(option) => option.responseTitle}
                      label="Enter City"
                      fullWidth
                    />
                  </div>

                  <div>
                    <p className="label_heading">
                      Do you have to Sell Before Buying?
                    </p>
                    <MDSelectInput
                      label="Select"
                      name="sellBeforeBuying"
                      value={values.sellBeforeBuying}
                      options={genericSellBeforeBuyingOptions}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        submitCount > 0 && Boolean(errors.sellBeforeBuying)
                      }
                      helperText={submitCount > 0 && errors.sellBeforeBuying}
                      fullWidth
                    />
                  </div>

                  <div>
                    <p className="label_heading">
                      Do you know when you're looking to move?
                    </p>
                    <MDSelectInput
                      label="Select"
                      name="movingTimeLine"
                      value={values.movingTimeLine}
                      options={buyerMovingOptions}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={submitCount > 0 && Boolean(errors.movingTimeLine)}
                      helperText={submitCount > 0 && errors.movingTimeLine}
                      fullWidth
                    />
                  </div>

                  <div>
                    <p className="label_heading">
                      What types of Homes are you interested in?
                    </p>
                    <MDSelectInput
                      label="Select"
                      name="homeType"
                      value={values.homeType}
                      options={buyerHomeTypeOptions}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={submitCount > 0 && Boolean(errors.homeType)}
                      helperText={submitCount > 0 && errors.homeType}
                      fullWidth
                    />
                  </div>

                  <div>
                    <p className="label_heading">
                      Which particular situation best describes you?
                    </p>
                    <MDSelectInput
                      label="Select"
                      name="buyerSituation"
                      value={values.buyerSituation}
                      options={buyerSituationOptions}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={submitCount > 0 && Boolean(errors.buyerSituation)}
                      helperText={submitCount > 0 && errors.buyerSituation}
                      fullWidth
                    />
                  </div>

                  <div>
                    <p className="label_heading">
                      What would you be interested in?
                    </p>
                    <MDSelectInput
                      label="Select"
                      name="interestedIn"
                      value={values.interestedIn}
                      options={buyerInterestedInOptions}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={submitCount > 0 && Boolean(errors.interestedIn)}
                      helperText={submitCount > 0 && errors.interestedIn}
                      fullWidth
                    />
                  </div>
                </>
              )}

              {currentStep === 3 && (
                <>
                  <div>
                    <p className="label_heading">
                      Do you have a Price Range in mind for you budget?
                    </p>
                    <MDSelectInput
                      label="Select"
                      name="priceRange"
                      value={values.priceRange}
                      options={priceRangeOptions}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={submitCount > 0 && Boolean(errors.priceRange)}
                      helperText={submitCount > 0 && errors.priceRange}
                      fullWidth
                    />
                  </div>

                  <div>
                    <p className="label_heading">
                      Have you spoken to a Mortgage Advisor?
                    </p>
                    <MDSelectInput
                      label="Select"
                      name="spokenWithAdvisor"
                      value={values.spokenWithAdvisor}
                      options={spokenWithAdvisorOptions}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        submitCount > 0 && Boolean(errors.spokenWithAdvisor)
                      }
                      helperText={submitCount > 0 && errors.spokenWithAdvisor}
                      fullWidth
                    />
                  </div>

                  <div>
                    <p className="label_heading">
                      How Many Beds should your new Home Have?
                    </p>
                    <MDSelectInput
                      label="Select"
                      name="bed"
                      value={values.bed}
                      options={bedOptions}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={submitCount > 0 && Boolean(errors.bed)}
                      helperText={submitCount > 0 && errors.bed}
                      fullWidth
                    />
                  </div>

                  <div>
                    <p className="label_heading">
                      How many Bathrooms should your new Home Have?
                    </p>
                    <MDSelectInput
                      label="Select"
                      name="bath"
                      value={values.bath}
                      options={bathOptions}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={submitCount > 0 && Boolean(errors.bath)}
                      helperText={submitCount > 0 && errors.bath}
                      fullWidth
                    />
                  </div>

                  <div>
                    <p className="label_heading">
                      Are there Specific home buying requirements like best
                      schools, best transit, bungalow, swimming pool, ravine
                      lookout, walkout basement, lake front, Larger room or
                      closet sizes, larger lot size, or anything else you can
                      think of?
                    </p>
                    <MDTextInput
                      label="Enter here"
                      name="specificRequirements"
                      value={values.specificRequirements}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        submitCount > 0 && Boolean(errors.specificRequirements)
                      }
                      helperText={
                        submitCount > 0 && errors.specificRequirements
                      }
                      fullWidth
                      multiline
                      rows={3}
                    />
                  </div>

                  <div>
                    <p className="label_heading">
                      Are you currently working with another realtor?
                    </p>
                    <MDSelectInput
                      label="Select"
                      name="workedWithAgent"
                      value={values.workedWithAgent}
                      options={workingWithAgentOptions}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={submitCount > 0 && Boolean(errors.workedWithAgent)}
                      helperText={submitCount > 0 && errors.workedWithAgent}
                      fullWidth
                    />
                  </div>
                </>
              )}

              {currentStep === 4 && (
                <>
                  <div>
                    <p className="label_heading">Let's set up a time to talk</p>
                    <MDSelectInput
                      label="Select"
                      name="meetingOpinion"
                      value={values.meetingOpinion}
                      options={genericBuyerMeetingOptions}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={submitCount > 0 && Boolean(errors.meetingOpinion)}
                      helperText={submitCount > 0 && errors.meetingOpinion}
                      fullWidth
                    />
                  </div>
                  <MDDateAndTimePicker
                    label="Choose Date and Time"
                    value={values?.meetingTime}
                    onChange={(newValue) => {
                      setFieldValue("meetingTime", newValue);
                    }}
                    error={submitCount > 0 && Boolean(errors.meetingTime)}
                    helperText={submitCount > 0 && errors.meetingTime}
                  />
                </>
              )}

              {currentStep === 5 && (
                <StartBuyingHomeThanks
                  userName={values.name}
                  phoneNumber={values.phone}
                  dateTime={values.meetingTime}
                />
              )}

              {submitError && (
                <p className="error_message m-0">
                  Error Submiting Form. Kindly submit again۔
                </p>
              )}

              <div
                className="w-100 d-flex align-item gap-3
              flex-wrap"
              >
                <button
                  type="submit"
                  className={`submit_button next_button ${
                    isSubmitting ? "disabled_btn" : ""
                  } ${currentStep === 4 ? "mbl_nextbtn" : ""} ${
                    currentStep === 5 ? "w-100" : ""
                  }`}
                  disabled={isSubmitting}
                >
                  {currentStep === 6
                    ? "Submit"
                    : currentStep === 5
                    ? "Let's talk about Lead’s Referral "
                    : currentStep === 4
                    ? "Let’s Get Connected"
                    : "Next"}
                </button>

                {currentStep !== 5 && (
                  <button
                    type="button"
                    className={`submit_button call_button 
                       ${isSubmitting ? "disabled_btn" : ""}
                      ${currentStep === 4 ? "mbl_callbtn" : ""}`}
                    disabled={isSubmitting}
                    onClick={() => {
                      submitForm();
                      setPhoneBtnClick(true);
                    }}
                  >
                    Call
                  </button>
                )}
              </div>

              {currentStep !== 5 && (
                <button
                  className={`Send_btn whatsApp_btn  ${
                    isSubmitting ? "disabled_btn" : ""
                  }`}
                  id="whatsApp_btn"
                  type="button"
                  disabled={isSubmitting}
                  onClick={() => {
                    setIsWhatsApp(true);
                    submitForm();
                  }}
                >
                  <img
                    src="https://config.assignmentsold.ca/attachments/newhomez-email/logos_whatsapp-icon.png"
                    alt="whatsapp_logo"
                  />
                  WhatsApp
                </button>
              )}
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default StartBuyingHomeForm;
